var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1512 11.8666C15.77 11.8666 16.2893 12.3772 16.1947 12.9882C15.6397 16.5827 12.5625 19.2515 8.85119 19.2515C4.7451 19.2515 1.41699 15.9234 1.41699 11.8183C1.41699 8.43614 3.98643 5.28563 6.87923 4.57329C7.50083 4.41982 8.13789 4.85707 8.13789 5.49702C8.13789 9.83283 8.28364 10.9544 9.10698 11.5645C9.93032 12.1745 10.8984 11.8666 15.1512 11.8666Z",
    stroke: "#12499C",
    strokeWidth: 1.65054,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1997 8.25582C19.2489 5.47016 15.8271 0.979917 11.6573 1.05714C11.333 1.06293 11.0734 1.33319 11.0589 1.65654C10.9537 3.94703 11.0956 6.91511 11.1747 8.26064C11.1989 8.67955 11.528 9.0087 11.946 9.03283C13.3291 9.11198 16.4053 9.22008 18.663 8.87839C18.9699 8.83206 19.1948 8.56566 19.1997 8.25582Z",
    stroke: "#12499C",
    strokeWidth: 1.65054,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/Graph.5497fdf3e9239cad9741f68c8c5bc8a9.svg";
export { ForwardRef as ReactComponent };